export default __webpack_public_path__ + "static/media/grid-2.7397dec5.svg";